import React from "react";
import { FormCard } from "@/components/FormCard";
import { Button } from "@/components/ui";

interface Props {
  hasChanges: boolean;
  isSaving: boolean;
  onCancel: () => void;
  onSave: () => void;
}

const SaveCancelActions: React.FC<Props> = ({ hasChanges, isSaving, onCancel, onSave }) => (
  <FormCard.Actions>
    <Button type="button" variant="outline" className="w-20" disabled={!hasChanges || isSaving} onClick={onCancel}>
      Cancel
    </Button>
    <Button type="button" loading={isSaving} className="w-20" disabled={!hasChanges} onClick={onSave}>
      Save
    </Button>
  </FormCard.Actions>
);

export { SaveCancelActions };
